module.exports = __webpack_public_path__ + "img/mobile-menu-spin.b64cfb15.webp";